{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "content",
  "x-cli-editable": true,
  "x-feature": true,
  "x-manage-link": "/curated-content",
  "title": "Content",
  "description": "Content recommendations during conversations. Includes curated content (articles, videos, case studies, tools) shown as clickable cards. Content groups and items are managed in the Curated Content page.",
  "type": "object",
  "properties": {
    "cooldown_turns": {
      "ui:sectionTitle": "Recommendations",
      "ui:sectionDescription": "How often Rose recommends content.",
      "ui:sectionIcon": "Sparkles",
      "type": "integer",
      "ui:description": "How many turns to wait before recommending content again. Set to 0 to allow recommendations on every turn (no cooldown). Set higher to space out recommendations.",
      "minimum": 0,
      "maximum": 20
    }
  },
  "default": {
    "cooldown_turns": 0
  }
}
